/** Kolory: dobór czytelnego koloru tekstu na tle w dowolnym kolorze (np. kolor branży z ustawień). */

export const TEXT_ON_LIGHT = '#212529';
export const TEXT_ON_DARK = '#ffffff';

/** Względna luminancja (WCAG 2.x) koloru #RRGGBB lub #RGB; niepoprawny zapis → null. */
export function luminance(hex: string): number | null {
  let h = hex.trim().replace(/^#/, '');
  if (/^[0-9a-f]{3}$/i.test(h)) h = [...h].map((c) => c + c).join('');
  if (!/^[0-9a-f]{6}$/i.test(h)) return null;
  const [r, g, b] = [0, 2, 4].map((i) => {
    const v = parseInt(h.slice(i, i + 2), 16) / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r! + 0.7152 * g! + 0.0722 * b!;
}

/** Współczynnik kontrastu dwóch kolorów (1–21); niepoprawny zapis → null. */
export function contrastRatio(a: string, b: string): number | null {
  const la = luminance(a);
  const lb = luminance(b);
  if (la === null || lb === null) return null;
  return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
}

/** Kolor tekstu (biały albo prawie czarny) o większym kontraście na danym tle; niepoprawny kolor tła → biały. */
export function readableTextColor(bg: string): string {
  const onDark = contrastRatio(bg, TEXT_ON_DARK);
  const onLight = contrastRatio(bg, TEXT_ON_LIGHT);
  if (onDark === null || onLight === null) return TEXT_ON_DARK;
  return onLight > onDark ? TEXT_ON_LIGHT : TEXT_ON_DARK;
}
